import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import NormalDialog from "../../Dialog/NormalDialog";
import ReturnCommentDialog from "../../Dialog/ReturnCommentDialog";

// Custom Component
import useLoading from "../../Loading/useLoading";
import ConfirmDialog from "../../Dialog/ConfirmDialog";
import SaveWarnDialog from "../../Dialog/SaveWarnDialog";
import FullScreenDialog from "../../Dialog/FullScreenDialog";
import TransmittalRecipientForm from "../RFI/RFIRecipientForm";
import ToCirculationConfirmDialog from "../../Dialog/ToCirculationComfirmDialog";
import WebViewer from "../../WebViewer/WebViewer";
import { Alert } from "../../Alert/Alert";
import LockScreenLoading from "../../LockScreenLoading/LockScreenLoading";

// Transmittal Section
import TransmittalMaster from "./transmittalSection/TransmittalMaster";
import TransmittalComment from "./transmittalSection/TransmittalComment";
import TransmittalReturnComment from "./transmittalSection/TransmittalReturnComment";
import TransmittalAssignList from "./transmittalSection/TransmittalAssignList";
import TransmittalAttachments from "./TransmittalAttachments";

import { webViewerSaveAnnotation } from "../../../global/webViewerSaveAnnotation";
// Custom Style
import { rfiDetailFormStyle } from "../../../styles/jss/components/RFI/rfiDetailFormStyle";
import {
  getUser,
  getUserGroupType,
  getUserGroup,
} from "../../../dataSource/circulation";

import {
  createTransmittal,
  getTransmittalDetails,
  getTransmittalStageList,
  postTransmittalComment,
  insertStageAction,
  updateTransmittal,
  updateTransmittalStage,
  generateTransmittal,
  updateTransmittalApproveStage,
  transferTransmittaltoEfiling,
} from "../../../dataSource/transmittal";

// Fetch Data
import { fileDownload } from "../../../dataSource/fileManager";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const store = require("store");

const TransmittalDetailsForm = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    setOpenDialog,
    isNew,
    xmtlSeq,
    buildAlert,
    setTabValue,
    transFromRFI,
    rfiToXmtlData,
  } = props;
  const userModulesRedux = useSelector((state) => state.userModulesRedux);
  const submissionTransmittalSoftCopyDetailRedux = useSelector(
    (state) => state.submissionTransmittalSoftCopyDetailRedux
  );
  const submissionTransmittalCommentRedux = useSelector(
    (state) => state.submissionTransmittalCommentRedux
  );
  // Loading
  const [getUserListLoading, getUserListShowLoading, getUserListHiddenLoading] =
    useLoading();
  const [
    getGroupListLoading,
    getGroupListShowLoading,
    getGroupListHiddenLoading,
  ] = useLoading();
  const [getDetailsLoading, getDetailsShowLoading, getDetailsHiddenLoading] =
    useLoading();
  const [
    updateDetailsLoading,
    updateDetailsShowLoading,
    updateDetailsHiddenLoading,
  ] = useLoading();
  const [xmtlToCirculateDialogOpen, setXmtlToCirculateDialogOpen] =
    useState(false);
  const [xmtlToCirculateDialogData, setXmtlToCirculateDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const [submissionValue, setSubmissionValue] = useState({
    recipients: {
      RESPONSIBLE: [],
      APPROVE: [],
      SECONDAPPROVER: [],
      THIRDAPPROVER: [],
      TOEXTERNAL: [],
      CC: [],
    },
    attention: "",
    xmtldate: null,
    following: [],
    purpose: [],
    remarks: "",
    is_returned: "",
    documents: [],
  });

  const [softCopyTemplate, setSoftCopyTemplate] = useState({
    id: "",
    material: "",
    ref_no: "",
    atthDate: null,
    description: "",
    messages: {
      parent_seq: 0,
      content: "",
      dms_property_seqs: [],
      files: [],
    },
  });
  const [submissionCommentValue, setSubmissionCommentValue] = useState({
    xmtlcomment: "",
  });
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  const [removeAtth, setRemoveAtth] = useState({ removeArr: [] });
  const [removeRecipientArray, setRemoveRecipientArray] = useState({
    removeArr: [],
  });

  const [transmittalStageList, setTransmittalStageList] = useState([]);
  const [commentvalidationErrors, setCommentValidationErrors] = useState({});
  const [userStageAction, setUserStageAction] = useState({
    IS_UPDATABLE: "N",
    IS_DETAIL_READABLE: "N",
    IS_APPROVABLE: "N",
    IS_CLOSABLE: "N",
    IS_TRANSMITTABLE: "N",
    IS_ATTACHMENT_READABLE: "N",
    IS_COMMENTABLE: "N",
    IS_COMMENT_READABLE: "N",
    IS_RETURNCOMMENT_READABLE: "N",
  });
  const [loadingFinish, setLoadingFinish] = useState(false);
  const [tmpGroupList, setTmpGroupList] = useState(null);
  const [editable, setEditable] = useState(false);
  const [stageBody, setStageBody] = useState({});
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const [webViewerProps, setWebViewerProps] = useState(null);
  const [returnCommentDialogOpen, setReturnCommentDialogOpen] = useState(false);
  const [returnCommentDialogData, setReturnCommentDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });

  const [filePreviewProperty, SetFilePreviewProperty] = useState(null);
  const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false);
  const [saveWarnDialogOpen, setSaveWarnDialogOpen] = useState(false);
  const [saveWarnDialogData, setSaveWarnDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    saveAction: "",
    dontSaveAction: "",
    cancelAction: "",
  });

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    title: "",
    content: "",
  });

  const [internalUserList, setInternalUserList] = useState(null);
  const [externalUserList, setExternalUserList] = useState(null);
  const [userGroupList, setUserGroupList] = useState(null);
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [internalOnly, setInternalOnly] = useState(true);
  const [dialogOpenName, setDialogOpenName] = useState(null);
  const [recipientType, setRecipientType] = useState(null);
  const [userGroupType, setUserGroupType] = useState(null);

  const [leftToExternalUserRcpt, setLeftToExternalUserRcpt] = useState(null);
  const [rightToExternalUserRcpt, setRightToExternalUserRcpt] = useState(null);
  const [leftToExternalGroupRcpt, setLeftToExternalGroupRcpt] = useState(null);
  const [rightToExternalGroupRcpt, setRightToExternalGroupRcpt] =
    useState(null);

  const [leftResponsibleUserRcpt, setLeftResponsibleUserRcpt] = useState(null);
  const [rightResponsibleUserRcpt, setRightResponsibleUserRcpt] =
    useState(null);
  const [leftResponsibleGroupRcpt, setLeftResponsibleGroupRcpt] =
    useState(null);
  const [rightResponsibleGroupRcpt, setRightResponsibleGroupRcpt] =
    useState(null);

  const [leftApproveUserRcpt, setLeftApproveUserRcpt] = useState(null);
  const [rightApproveUserRcpt, setRightApproveUserRcpt] = useState(null);
  const [leftApproveGroupRcpt, setLeftApproveGroupRcpt] = useState(null);
  const [rightApproveGroupRcpt, setRightApproveGroupRcpt] = useState(null);

  const [leftCcUserRcpt, setLeftCcUserRcpt] = useState(null);
  const [rightCcUserRcpt, setRightCcUserRcpt] = useState(null);
  const [leftCcGroupRcpt, setLeftCcGroupRcpt] = useState(null);
  const [rightCcGroupRcpt, setRightCcGroupRcpt] = useState(null);

  const [leftSecondApproveUserRcpt, setLeftSecondApproveUserRcpt] =
    useState(null);
  const [rightSecondApproveUserRcpt, setRightSecondApproveUserRcpt] =
    useState(null);
  const [leftSecondApproveGroupRcpt, setLeftSecondApproveGroupRcpt] =
    useState(null);
  const [rightSecondApproveGroupRcpt, setRightSecondApproveGroupRcpt] =
    useState(null);

  const [leftThirdApproveUserRcpt, setLeftThirdApproveUserRcpt] =
    useState(null);
  const [rightThirdApproveUserRcpt, setRightThirdApproveUserRcpt] =
    useState(null);
  const [leftThirdApproveGroupRcpt, setLeftThirdApproveGroupRcpt] =
    useState(null);
  const [rightThirdApproveGroupRcpt, setRightThirdApproveGroupRcpt] =
    useState(null);

  const [selectUserDialogOpen, setSelectUserDialogOpen] = useState(false);

  const [selectHardCopyDialogOpen, setSelectHardCopyDialogOpen] =
    useState(false);

  const [validationErrors, setValidationErrors] = useState({});

  // Input Validation
  const validate = (fieldValues = submissionValue) => {
    let temp = { ...validationErrors };

    if ("xmtldate" in fieldValues) {
      temp.xmtldate = fieldValues.xmtldate ? "" : "This field is required";
    }

    if ("purpose" in fieldValues) {
      temp.purpose =
        fieldValues.purpose.length > 0 ? "" : "This field is required";
    }
    if ("following" in fieldValues) {
      temp.following =
        fieldValues.following.length > 0 ? "" : "This field is required";
    }
    if ("RESPONSIBLE" in fieldValues.recipients) {
      temp.RESPONSIBLE =
        fieldValues.recipients.RESPONSIBLE.length > 0
          ? ""
          : "This field is required";
    }
    if ("APPROVE" in fieldValues.recipients) {
      temp.APPROVE =
        fieldValues.recipients.APPROVE.length > 0
          ? ""
          : "This field is required";
    }
    if ("TOEXTERNAL" in fieldValues.recipients) {
      temp.TOEXTERNAL =
        fieldValues.recipients.TOEXTERNAL.length > 0
          ? ""
          : "This field is required";
    }

    setValidationErrors({ ...temp });

    if (fieldValues == submissionValue) {
      return Object.values(temp).every((x) => x == "");
    }
  };
  // Handle Dialog open and close
  const selectHardCopyHandleOpen = () => {
    setSelectHardCopyDialogOpen(true);
  };

  const selectHardCopyHandleClose = () => {
    setSelectHardCopyDialogOpen(false);
  };

  const submitTransmittalAtth = () => {
    setSelectHardCopyDialogOpen(false);
  };

  const hardCopyDialogBtn = [
    {
      buttonName: "Close",
      buttonFunction: selectHardCopyHandleClose,
      chooseFile: false,
    },
  ];

  // Handle Dialog open and close
  const selectRcptDialogHandleOpen = (type, dialogOpenName) => {
    setRecipientType(type);
    setDialogOpenName(dialogOpenName);
    setSelectUserDialogOpen(true);
  };

  const selectRcptDialogHandleClose = () => {
    setRecipientType(null);
    setSelectUserDialogOpen(false);
  };
  const recipientDialogBtn = [
    {
      buttonName: "Close",
      buttonFunction: selectRcptDialogHandleClose,
      chooseFile: false,
    },
  ];

  const handleRecipientClipClick = (popoverId) => (event) => {
    setOpenPopoverId(popoverId);
    setAnchorEl(event.currentTarget);
  };

  const handleRecipientClipClose = () => {
    setOpenPopoverId(null);
    setAnchorEl(null);
  };

  const reciptentChipAdd = (type, recipientRec) => {
    let tempRecipients = {
      RESPONSIBLE: [...submissionValue.recipients.RESPONSIBLE],
      APPROVE: [...submissionValue.recipients.APPROVE],
      SECONDAPPROVER: [...submissionValue.recipients.SECONDAPPROVER],
      THIRDAPPROVER: [...submissionValue.recipients.THIRDAPPROVER],
      TOEXTERNAL: [...submissionValue.recipients.TOEXTERNAL],
      CC: [...submissionValue.recipients.CC],
    };

    if (type === "USER") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].push({
            rcpt_type: "USER", // USER, USERGROUP
            site_user_seq: res.site_user_seq,
            fullname: res.fullname,
            is_attachment_readable: "Y",
          });
        });
      }
    } else if (type === "GROUP") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].push({
            rcpt_type: "USERGROUP", // USER, USERGROUP
            type_seq: res.type_seq,
            group_seq: res.group_seq,
            group_name: res.group_name,
            group_members: res.group_members,
            is_attachment_readable: "Y",
          });
        });
      }
    }

    setSubmissionValue({ ...submissionValue, recipients: tempRecipients });
    dispatch({
      type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
      data: { ...submissionValue, recipients: tempRecipients },
    });
    if (
      (validationErrors.RESPONSIBLE && validationErrors.RESPONSIBLE !== "") ||
      (validationErrors.APPROVE && validationErrors.APPROVE !== "") ||
      (validationErrors.TOEXTERNAL && validationErrors.TOEXTERNAL !== "")
        ? true
        : false
    ) {
      validate({ ...submissionValue, recipients: tempRecipients });
    }
  };

  const removeRecipientAction = (recipientType, typeSeq, removeRec) => {
    removeRecipient(recipientType, removeRec);
    moveTransferListData(recipientType, typeSeq, removeRec);
  };

  const removeRecipient = (recipientType, removeRec) => {
    let result = {
      RESPONSIBLE: [...submissionValue.recipients.RESPONSIBLE],
      APPROVE: [...submissionValue.recipients.APPROVE],
      SECONDAPPROVER: [...submissionValue.recipients.SECONDAPPROVER],
      THIRDAPPROVER: [...submissionValue.recipients.THIRDAPPROVER],
      TOEXTERNAL: [...submissionValue.recipients.TOEXTERNAL],
      CC: [...submissionValue.recipients.CC],
    };
    result[recipientType] = submissionValue.recipients[recipientType].filter(
      (rec) => rec !== removeRec
    );
    if (result["APPROVE"].length === 0) {
      result["SECONDAPPROVER"] = [];
      result["THIRDAPPROVER"] = [];
      setRightSecondApproveUserRcpt([]);
      setRightSecondApproveGroupRcpt(tmpGroupList);
      setRightThirdApproveUserRcpt([]);
      setRightThirdApproveGroupRcpt(tmpGroupList);
    }
    if (result["SECONDAPPROVER"].length === 0) {
      result["THIRDAPPROVER"] = [];
      setRightThirdApproveUserRcpt([]);
      setRightThirdApproveGroupRcpt(tmpGroupList);
    }
    let data = { ...removeRecipientArray };
    data.removeArr.push(removeRec.rcpt_seq);
    setRemoveRecipientArray({ ...removeRecipientArray, data });
    setSubmissionValue({ ...submissionValue, recipients: result });
  };
  const moveTransferListData = (recipientType, typeSeq, removeRec) => {
    let groupRightResult =
      recipientType === "TOEXTERNAL"
        ? { ...rightToExternalGroupRcpt }
        : recipientType === "CC"
        ? { ...rightCcGroupRcpt }
        : recipientType === "RESPONSIBLE"
        ? { ...rightResponsibleGroupRcpt }
        : recipientType === "APPROVE"
        ? { ...rightApproveGroupRcpt }
        : recipientType === "SECONDAPPROVER"
        ? { ...rightSecondApproveGroupRcpt }
        : recipientType === "THIRDAPPROVER"
        ? { ...rightThirdApproveGroupRcpt }
        : [];
    let groupLeftResult =
      recipientType === "TOEXTERNAL"
        ? { ...leftToExternalGroupRcpt }
        : recipientType === "CC"
        ? { ...leftCcGroupRcpt }
        : recipientType === "RESPONSIBLE"
        ? { ...leftResponsibleGroupRcpt }
        : recipientType === "APPROVE"
        ? { ...leftApproveGroupRcpt }
        : recipientType === "SECONDAPPROVER"
        ? { ...leftSecondApproveGroupRcpt }
        : recipientType === "THIRDAPPROVER"
        ? { ...leftThirdApproveGroupRcpt }
        : [];
    if (removeRec.rcpt_type === "USER") {
      if (recipientType === "TOEXTERNAL") {
        setRightToExternalUserRcpt(
          rightToExternalUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftToExternalUserRcpt([
          ...leftToExternalUserRcpt,
          ...rightToExternalUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "CC") {
        setRightCcUserRcpt(
          rightCcUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftCcUserRcpt([
          ...leftCcUserRcpt,
          ...rightCcUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "RESPONSIBLE") {
        setRightResponsibleUserRcpt(
          rightResponsibleUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftResponsibleUserRcpt([
          ...leftResponsibleUserRcpt,
          ...rightResponsibleUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "APPROVE") {
        setRightApproveUserRcpt(
          rightApproveUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftApproveUserRcpt([
          ...leftApproveUserRcpt,
          ...rightApproveUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "SECONDAPPROVER") {
        setRightSecondApproveUserRcpt(
          rightSecondApproveUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftSecondApproveUserRcpt([
          ...leftSecondApproveUserRcpt,
          ...rightSecondApproveUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "THIRDAPPROVER") {
        setRightThirdApproveUserRcpt(
          rightThirdApproveUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftThirdApproveUserRcpt([
          ...leftThirdApproveUserRcpt,
          ...rightThirdApproveUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      }
    } else if (removeRec.rcpt_type === "USERGROUP") {
      if (recipientType === "TOEXTERNAL") {
        groupRightResult[typeSeq] = rightToExternalGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightToExternalGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightToExternalGroupRcpt({
          ...rightToExternalGroupRcpt,
          ...groupRightResult,
        });
        setLeftToExternalGroupRcpt({
          ...leftToExternalGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "CC") {
        groupRightResult[typeSeq] = rightCcGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightCcGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightCcGroupRcpt({ ...rightCcGroupRcpt, ...groupRightResult });
        setLeftCcGroupRcpt({ ...leftCcGroupRcpt, ...groupLeftResult });
      } else if (recipientType === "RESPONSIBLE") {
        groupRightResult[typeSeq] = rightResponsibleGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightResponsibleGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );
        setRightResponsibleGroupRcpt({
          ...rightResponsibleGroupRcpt,
          ...groupRightResult,
        });
        setLeftResponsibleGroupRcpt({
          ...leftResponsibleGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "APPROVE") {
        groupRightResult[typeSeq] = rightApproveGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightApproveGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );
        setRightApproveGroupRcpt({
          ...rightApproveGroupRcpt,
          ...groupRightResult,
        });
        setLeftApproveGroupRcpt({
          ...leftApproveGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "SECONDAPPROVER") {
        groupRightResult[typeSeq] = rightSecondApproveGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightSecondApproveGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightSecondApproveGroupRcpt({
          ...rightSecondApproveGroupRcpt,
          ...groupRightResult,
        });
        setLeftSecondApproveGroupRcpt({
          ...leftSecondApproveGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "THIRDAPPROVER") {
        groupRightResult[typeSeq] = rightThirdApproveGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightThirdApproveGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightThirdApproveGroupRcpt({
          ...rightThirdApproveGroupRcpt,
          ...groupRightResult,
        });
        setLeftThirdApproveGroupRcpt({
          ...leftThirdApproveGroupRcpt,
          ...groupLeftResult,
        });
      }
    }
  };

  const reciptentChipRemove = (type, recipientRec) => {
    let tempRecipients = {
      RESPONSIBLE: [...submissionValue.recipients.RESPONSIBLE],
      APPROVE: [...submissionValue.recipients.APPROVE],
      SECONDAPPROVER: [...submissionValue.recipients.SECONDAPPROVER],
      THIRDAPPROVER: [...submissionValue.recipients.THIRDAPPROVER],
      TOEXTERNAL: [...submissionValue.recipients.TOEXTERNAL],
      CC: [...submissionValue.recipients.CC],
    };

    if (type === "USER") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].map((data, index) => {
            if (res.site_user_seq === data.site_user_seq) {
              tempRecipients[recipientType].splice(index, 1);
            }
          });
        });
      }
    } else if (type === "GROUP") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].map((data, index) => {
            if (res.group_seq === data.group_seq) {
              tempRecipients[recipientType].splice(index, 1);
            }
          });
        });
      }
    }

    let data = { ...removeRecipientArray };
    data.removeArr.push(recipientRec[0].rcpt_seq);
    setRemoveRecipientArray({ ...removeRecipientArray, data });
    setSubmissionValue({ ...submissionValue, recipients: tempRecipients });
    dispatch({
      type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
      data: { ...submissionValue, recipients: tempRecipients },
    });
  };

  // Build Confirm Dialog
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  const deleteAtthConfirmAction = (id, file_seq, atth_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Delete Attachment",
      dialogContent: "Are you sure to delete this record?",
      confirmAction: () => deleteAtthConfirm(id, file_seq, atth_seq),
      cancelAction: postCommentCancelAction,
    });
  };

  const deleteAtthConfirm = (id, file_seq, atth_seq) => {
    confirmDialogHandleClose();
    let data = { ...submissionValue.documents };
    data = submissionValue.documents.filter((obj) => obj.id !== id);
    setSubmissionValue({ ...submissionValue, documents: data });
    console.log(submissionValue.documents);
    let removeData = { ...removeAtth };
    if (atth_seq !== undefined) {
      removeData.removeArr.push(atth_seq);
    }
    setRemoveAtth({ ...removeAtth, ...removeData });

    let result;
    let softCopydata = { ...submissionTransmittalSoftCopyDetailRedux };

    result = [
      ...submissionTransmittalSoftCopyDetailRedux.messages.files,
    ].filter((res) => res.file_seq !== file_seq);

    softCopydata.messages.files = result;

    dispatch({
      type: "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE",
      data: { ...submissionTransmittalSoftCopyDetailRedux, ...softCopydata },
    });
  };

  // Confirm Dialog action
  const postCommentConfirmAction = (xmtl_seq) => {
    if (commentvalidate()) {
      confirmDialogHandleOpen({
        dialogTitle: "Add new comment of Transmittal",
        dialogContent: "Are you sure to post comment?",
        confirmAction: () => postCommentConfirm(xmtl_seq),
        cancelAction: postCommentCancelAction,
      });
    }
  };
  // Main Comment Action
  const postCommentConfirm = (xmtl_seq) => {
    confirmDialogHandleClose();
    submissionTransmittalCommentRedux.stageCode = "COMMENTED";
    submissionTransmittalCommentRedux.isTransmit = "N";
    postTransmittalComment(xmtl_seq, submissionTransmittalCommentRedux).then(
      (res) => {
        buildAlert({
          type: "success",
          title: "Success Alert",
          content: "The comment have been posted",
        });
        setOpenDialog(false);
        console.log(
          "*****************************************************************************"
        );
        console.log("System Module: Transmittal");
        console.log("Message: Post Comment Successful.");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
      }
    );
  };

  const postCommentCancelAction = () => {
    confirmDialogHandleClose();
  };

  const commentvalidate = (fieldValues = submissionCommentValue) => {
    let temp = { ...commentvalidationErrors };
    if ("xmtlcomment" in fieldValues) {
      temp.xmtlcomment = fieldValues.xmtlcomment
        ? ""
        : "This field is required";
    }

    setCommentValidationErrors({ ...temp });
    if (fieldValues == submissionCommentValue) {
      return Object.values(temp).every((x) => x == "");
    }
  };

  const getLeftAndRightRecipients = (userList, groupList, recipientType) => {
    let toLeftData = [];
    let toRightData = [];

    let keys = groupList && Object.keys(groupList);
    let ToLeftGroupData = {};
    let ToRightGroupdata = {};

    for (let j = 0; j < keys.length; j++) {
      let groupKey = keys[j];

      var object = {
        [groupKey]: [],
      };
      ToLeftGroupData = { ...ToLeftGroupData, ...object };
      ToRightGroupdata = { ...ToRightGroupdata, ...object };
    }

    for (let i = 0; i < submissionValue.recipients[recipientType].length; i++) {
      let internalUser = toLeftData.length === 0 ? userList : toLeftData;
      if (submissionValue.recipients[recipientType][i].rcpt_type === "USER") {
        toLeftData =
          userList.length > 0 &&
          internalUser.filter(
            (obj) =>
              obj.site_user_seq !==
              submissionValue.recipients[recipientType][i].site_user_seq
          );

        let ToRight =
          userList.length > 0 &&
          userList.find(
            (obj) =>
              obj.site_user_seq ===
              submissionValue.recipients[recipientType][i].site_user_seq
          );
        toRightData.push(ToRight);
      }
      if (
        submissionValue.recipients[recipientType][i].rcpt_type === "USERGROUP"
      ) {
        for (const [key, value] of Object.entries(groupList)) {
          groupList[key] =
            ToLeftGroupData[key].length > 0
              ? ToLeftGroupData[key]
              : groupList[key];

          if (submissionValue.recipients[recipientType][i].type_seq == key) {
            ToLeftGroupData[key] = groupList[key].filter(
              (obj) =>
                obj.group_seq !==
                submissionValue.recipients[recipientType][i].group_seq
            );
            let ToRightGroup =
              groupList[key].find(
                (obj) =>
                  obj.group_seq ===
                  submissionValue.recipients[recipientType][i].group_seq
              ) !== undefined
                ? groupList[key].find(
                    (obj) =>
                      obj.group_seq ===
                      submissionValue.recipients[recipientType][i].group_seq
                  )
                : submissionValue.recipients[recipientType][i];
            let obj = {
              is_attachment_readable: "Y",
              rcpt_type: "USERGROUP",

              rcpt_seq: submissionValue.recipients[recipientType][i].rcpt_seq,
              group_name:
                submissionValue.recipients[recipientType][i].rcpt_name,
            };
            ToRightGroup = { ...ToRightGroup, ...obj };

            ToRightGroupdata[key].push(ToRightGroup);

            let data = { ...submissionValue };
            submissionValue.recipients[recipientType][i] = ToRightGroup;
            setSubmissionValue({ ...submissionValue, ...data });
          }
        }
      }
    }
    let dataList = {
      left: toLeftData,
      right: toRightData,
      leftGroup: ToLeftGroupData,
      rightGroup: ToRightGroupdata,
    };
    return dataList;
  };

  const handleEditClick = () => {
    let softCopyData = { ...softCopyTemplate };
    for (const doc of submissionValue.documents) {
      if (doc.type === "softcopy") {
        softCopyData.messages.files.push(doc.files);
        setSoftCopyTemplate({ ...softCopyTemplate, ...softCopyData });
      }
      dispatch({
        type: "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE",
        data: { ...softCopyTemplate, ...softCopyData },
      });
    }

    let responseObj = {
      recipientType: "RESPONSIBLE",
    };
    let responseGroupList = { ...userGroupList, ...responseObj };
    let responsibleData = getLeftAndRightRecipients(
      internalUserList,
      responseGroupList,
      "RESPONSIBLE"
    );

    setLeftResponsibleUserRcpt(responsibleData.left);
    setRightResponsibleUserRcpt(responsibleData.right);
    setLeftResponsibleGroupRcpt(responsibleData.leftGroup);
    setRightResponsibleGroupRcpt(responsibleData.rightGroup);

    let approveObj = {
      recipientType: "APPROVE",
    };
    let approveGroupList = { ...userGroupList, ...approveObj };
    let approveData = getLeftAndRightRecipients(
      internalUserList,
      approveGroupList,
      "APPROVE"
    );
    setLeftApproveUserRcpt(approveData.left);
    setRightApproveUserRcpt(approveData.right);
    setLeftApproveGroupRcpt(approveData.leftGroup);
    setRightApproveGroupRcpt(approveData.rightGroup);

    let secondApproverObj = {
      recipientType: "SECONDsecondApproverR",
    };
    let secondApproverGroupList = { ...userGroupList, ...secondApproverObj };
    let secondApproverData = getLeftAndRightRecipients(
      internalUserList,
      secondApproverGroupList,
      "SECONDAPPROVER"
    );
    setLeftSecondApproveUserRcpt(secondApproverData.left);
    setRightSecondApproveUserRcpt(secondApproverData.right);
    setLeftSecondApproveGroupRcpt(secondApproverData.leftGroup);
    setRightSecondApproveGroupRcpt(secondApproverData.rightGroup);

    let thirdapproverObj = {
      recipientType: "THIRDAPPROVER",
    };
    let thirdapproverGroupList = { ...userGroupList, ...thirdapproverObj };
    let thirdapproverData = getLeftAndRightRecipients(
      internalUserList,
      thirdapproverGroupList,
      "THIRDAPPROVER"
    );
    setLeftThirdApproveUserRcpt(thirdapproverData.left);
    setRightThirdApproveUserRcpt(thirdapproverData.right);
    setLeftThirdApproveGroupRcpt(thirdapproverData.leftGroup);
    setRightThirdApproveGroupRcpt(thirdapproverData.rightGroup);

    let toObj = {
      recipientType: "to",
    };
    let toGroupList = { ...userGroupList, ...toObj };
    let toData = getLeftAndRightRecipients(
      externalUserList,
      toGroupList,
      "TOEXTERNAL"
    );
    setLeftToExternalUserRcpt(toData.left);
    setRightToExternalUserRcpt(toData.right);
    setLeftToExternalGroupRcpt(toData.leftGroup);
    setRightToExternalGroupRcpt(toData.rightGroup);

    let CcObj = {
      recipientType: "CC",
    };
    let CcGroupList = { ...userGroupList, ...CcObj };
    let list = externalUserList.concat(internalUserList);

    let CcData = getLeftAndRightRecipients(list, CcGroupList, "CC");
    setLeftCcUserRcpt(CcData.left);
    setRightCcUserRcpt(CcData.right);
    setLeftCcGroupRcpt(CcData.leftGroup);
    setRightCcGroupRcpt(CcData.rightGroup);

    setEditable(true);
  };

  const filePreviewDialogHandleOpen = () => {
    setFilePreviewDialogOpen(true);
  };
  const alertSaveActionHandleOpen = () => {
    saveWarnDialogHandleOpen({
      dialogTitle: "Annotation Change Warning",
      dialogContent: "Do you want to save the change of annotation.",
      saveAction: alertSaveAnnotation,
      dontSaveAction: alertDontSaveAnnotation,
      cancelAction: alertSaveActionHandleClose,
    });
  };

  // Build Return Comment Dialog
  const returnCommentDialogHandleOpen = (data) => {
    setReturnCommentDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      xmtl_seq: data.xmtl_seq,
      my_rcpt_type: data.my_rcpt_type,
      stageCode: data.stageCode,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setReturnCommentDialogOpen(true);
  };

  const returnCommentDialogHandleClose = () => {
    setReturnCommentDialogOpen(false);
  };

  const returnTransmittalConfirmAction = () => {
    returnCommentDialogHandleOpen({
      dialogTitle: "Return Transmittal",
      dialogContent: "Please leave return comment",
      xmtl_seq: xmtlSeq,
      my_rcpt_type: submissionValue.my_rcpt_type,
      stageCode: submissionValue.stageCode,
      cancelAction: returnCommentDialogHandleClose,
    });
  };

  const filePreviewDialogHandleClose = () => {
    if (!store.get("annotActive")) {
      setFilePreviewDialogOpen(false);
    } else {
      alertSaveActionHandleOpen();
    }
  };

  const downloadFileAction = (fileCat, fileSeq) => {
    fileDownload(fileCat, fileSeq).then((res) => {
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Document Submission");
      console.log("Message: File download successful.");
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const viewFileAction = (fileCat, fileSeq, filename) => {
    SetFilePreviewProperty({
      from: "API",
      autoLoading: true,
      file_cat: fileCat,
      file_ref: fileSeq,
      file_name: filename,
    });

    filePreviewDialogHandleOpen();
  };

  let fileAttachmentPreviewDialogBtn = [];

  // Build Save Warn Dialog
  const saveWarnDialogHandleOpen = (data) => {
    setSaveWarnDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      saveAction: data.saveAction,
      dontSaveAction: data.dontSaveAction,
      cancelAction: data.cancelAction,
    });
    setSaveWarnDialogOpen(true);
  };

  const saveWarnDialogHandleClose = () => {
    setSaveWarnDialogOpen(false);
  };

  const alertSaveActionHandleClose = () => {
    saveWarnDialogHandleClose();
  };

  const alertSaveAnnotation = () => {
    annotationSaveAction();
    alertSaveActionHandleClose();
    setFilePreviewDialogOpen(false);
  };

  const alertDontSaveAnnotation = () => {
    alertSaveActionHandleClose();
    setFilePreviewDialogOpen(false);
  };
  const annotationSaveActionHandleOpen = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Annotation Save",
      dialogContent: "Are you sure to save the annotation.",
      confirmAction: annotationSaveAction,
      cancelAction: annotationSaveActionHandleClose,
    });
  };

  if (userModulesRedux !== null) {
    userModulesRedux.map((module) => {
      // if (module.path === "/circulation") {
      if (module.rights.modifiable || module.rights.administrable) {
        // if (isNew || editable) {
        //   fileAttachmentPreviewDialogBtn = [
        //     {
        //       buttonName: "Annotation Save",
        //       buttonFunction: annotationSaveActionHandleOpen,
        //       chooseFile: false,
        //     },
        //   ];
        // }
      }
    });
  }
  const annotationSaveAction = () => {
    webViewerSaveAnnotation(
      filePreviewProperty.fileCategory,
      filePreviewProperty.fileSequence
    ).then((res) => {
      annotationSaveActionHandleClose();

      if (res.type === "success") {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The Annotation have been save",
        });
      } else {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "error",
          title: "Error Alert",
          content: res.message,
        });
      }
    });
  };

  const annotationSaveActionHandleClose = () => {
    confirmDialogHandleClose();
  };

  const createTransmittalAction = () => {
    if (validate()) {
      confirmDialogHandleOpen({
        dialogTitle: "Create Transmittal",
        dialogContent: "Are you sure to create Transmittal",
        confirmAction: () => createTransmittalConfirmAction(),
        cancelAction: confirmDialogHandleClose,
      });
    }
  };

  const createTransmittalConfirmAction = () => {
    createTransmittal(submissionValue).then((res) => {
      if (transFromRFI) {
        window.location.href = "/transmittal";
      }
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The transmittal have been created",
      });
      // setOpenDialog(false);
      setOpenDialog(false);
      setTabValue(0);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Transmittal");
      console.log("Message: Create Transmittal Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const handleSaveClick = (xmtlSeq) => {
    if (validate()) {
      confirmDialogHandleOpen({
        dialogTitle: "Save Transmittal",
        dialogContent: "Are you sure to save Transmittal?",
        confirmAction: () => saveTransmittalConfirmAction(xmtlSeq),
        cancelAction: confirmDialogHandleClose,
      });
    }
  };

  const saveTransmittalConfirmAction = (xmtlSeq) => {
    confirmDialogHandleClose();
    let submissionUpdateBody = {
      xmtldate: submissionValue.xmtldate,
      remarks: submissionValue.remarks,
      attention: submissionValue.attention,
      recipients: submissionValue.recipients,
      purpose: submissionValue.purpose,
      following: submissionValue.following,
      documents: submissionValue.documents,
      removeAtthArr: removeAtth.removeArr,
      removeRecipientArr: removeRecipientArray.removeArr,
    };
    updateDetailsShowLoading();

    updateTransmittal(xmtlSeq, submissionUpdateBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The Transmittal have been saved",
      });
      setOpenDialog(false);
      // setTabValue(0);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Transmittal");
      console.log("Message: Save Transmittal Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
      updateDetailsHiddenLoading();
    });
  };

  const approveTransmittalConfirmAction = (xmtl_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Approve Transmittal",
      dialogContent: "Are you sure to approve transmittal?",
      confirmAction: () => approveTransmittalAction(xmtl_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const approveTransmittalAction = (xmtl_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = submissionValue.stageCode;

    updateTransmittalApproveStage(xmtl_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The Transmittal have been approved",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Transmittal");
      console.log("Message: Approve Transmittal Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const sendTransmittalConfirmAction = (xmtl_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Send Transmittal",
      dialogContent: "Are you sure to send transmittal?",
      confirmAction: () => sendTransmittalAction(xmtl_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const sendTransmittalAction = (xmtl_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = "TRANSMITTED";
    stageBody.isTransmit = "Y";

    updateTransmittalStage(xmtl_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The Transmittal have been sent",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Transmittal");
      console.log("Message: Send Transmittal Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };
  const closeTransmittalConfirmAction = (xmtl_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Close Transmittal",
      dialogContent: "Are you sure to close transmittal?",
      confirmAction: () => closeTransmittalAction(xmtl_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };
  const closeTransmittalAction = (xmtl_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = "CLOSED";
    stageBody.isTransmit = "Y";

    updateTransmittalStage(xmtl_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The Transmittal have been closed",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Transmittal");
      console.log("Message: Close Transmittal Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };
  const cancelandBackAction = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Cancel and Back",
      dialogContent:
        "Are you sure want to cancel and back? Any changes made will be unsaved",
      confirmAction: () => cancelandBack(),
      cancelAction: confirmDialogHandleClose,
    });
  };
  const cancelandBack = () => {
    setOpenDialog(false);
    if (isNew) {
      setTabValue(0);
    }
  };
  const generatePdf = () => {
    let submissionBody = {};
    submissionBody.xmtl_seq = xmtlSeq;
    submissionBody.ref_no = submissionValue.ref_no;
    setLockScreenLoadingOpen(true);

    generateTransmittal(submissionBody).then((res) => {
      setLockScreenLoadingOpen(false);
    });
  };

  // Get Data
  const getUserListAction = () => {
    getUserListShowLoading();
    getUser(!internalOnly).then((res) => {
      let externalList = res.data.map((obj) => ({
        ...obj,
        userType: "external",
      }));
      setExternalUserList(externalList);
      dispatch({
        type: "ADD_EXTERNAL_USER_LIST",
        data: res.data,
      });
      getUserListHiddenLoading();
    });
    getUser(internalOnly).then((res) => {
      let internalList = res.data.map((obj) => ({
        ...obj,
        userType: "internal",
      }));
      setInternalUserList(internalList);
      dispatch({
        type: "ADD_INTERNAL_USER_LIST",
        data: res.data,
      });
      getUserListHiddenLoading();
    });
  };
  const getGroupListAction = (groupTypeList) => {
    getGroupListShowLoading();

    let tempLeftGroupList = {};
    let tempRightGroupList = {};

    if (groupTypeList !== null) {
      groupTypeList.map((type) => {
        getUserGroup(type.type_seq).then((res) => {
          tempLeftGroupList[type.type_seq] = res.data;
          tempRightGroupList[type.type_seq] = [];
          setLeftCcGroupRcpt(tempLeftGroupList);
          setRightCcGroupRcpt(tempRightGroupList);
          setLeftResponsibleGroupRcpt(tempLeftGroupList);
          setRightResponsibleGroupRcpt(tempRightGroupList);
          setLeftApproveGroupRcpt(tempLeftGroupList);
          setRightApproveGroupRcpt(tempRightGroupList);
          setLeftSecondApproveGroupRcpt(tempLeftGroupList);
          setRightSecondApproveGroupRcpt(tempRightGroupList);
          setLeftThirdApproveGroupRcpt(tempLeftGroupList);
          setRightThirdApproveGroupRcpt(tempRightGroupList);
          setLeftToExternalGroupRcpt(tempLeftGroupList);
          setRightToExternalGroupRcpt(tempRightGroupList);
          setUserGroupList(tempLeftGroupList);
          setTmpGroupList(tempRightGroupList);

          dispatch({
            type: "ADD_USER_GROUP_LIST",
            data: tempLeftGroupList,
          });
          getGroupListHiddenLoading();
        });
      });
    }
  };
  const circulationHandleClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    getUserGroupType().then((res) => {
      setUserGroupType(res.data);
      getUserListAction();
      getGroupListAction(res.data);
    });
  }, []);

  const xmtlToCirculateDialogHandleOpen = (data) => {
    setXmtlToCirculateDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
      xmtl_seq: data.xmtl_seq,
      ref_no: data.ref_no,
    });

    setXmtlToCirculateDialogOpen(true);
  };

  const xmtlToCirculateDialogHandleClose = () => {
    setXmtlToCirculateDialogOpen(false);
  };

  const getTransmittalAction = async () => {
    const response = await getTransmittalDetails(xmtlSeq);
    setSubmissionValue(response.data);
    dispatch({
      type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
      data: { ...submissionValue, ...response.data },
    });
    return response.data;
  };

  const circulateAction = () => {
    xmtlToCirculateDialogHandleOpen({
      dialogTitle: "Circulate this Transmittal",
      dialogContent: "Are you sure to circulate this Transmittal?",
      xmtl_seq: xmtlSeq,
      ref_no: submissionValue.ref_no,

      confirmAction: () => circulateConfirmAction(),
      cancelAction: xmtlToCirculateDialogHandleClose,
    });
  };

  const circulateConfirmAction = () => {
    setXmtlToCirculateDialogOpen(true);
  };

  const eFilingAction = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Save Transmittal To Efiling",
      dialogContent: "Are you sure to save this Transmittal to eFiling?",
      confirmAction: () => eFilngConfirmAction(),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const eFilngConfirmAction = async () => {
    try {
      let postBody = {
        xmtl_seq: xmtlSeq,
        ref_no: submissionValue.ref_no,
        remark: submissionValue.remarks,
        targeted_site_user_seq:
          submissionValue.recipients.TOEXTERNAL[0].site_user_seq,
      };
      confirmDialogHandleClose();
      setLockScreenLoadingOpen(true);
      const response = await transferTransmittaltoEfiling(postBody);
      setLockScreenLoadingOpen(false);
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The transmittal have been transfer to eFiling",
      });
      setOpenDialog(false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (transFromRFI) {
      let data = { ...submissionValue };
      data.documents.push(rfiToXmtlData);
      setSubmissionValue({ ...submissionValue, ...data });
      dispatch({
        type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
        data: { ...submissionValue, data },
      });
    }
    if (!isNew) {
      getDetailsShowLoading();
      const fetchTransmittalAction = async () => {
        const details = await getTransmittalAction();
        let insertStageBody = {
          xmtl_seq: xmtlSeq,
          stage_seq: details.stage_seq,
          rcptBody: details.my_rcpt_type,
        };
        await insertStageAction(insertStageBody);
        let rcpts = details.my_rcpt_type.join("");
        const stagelist = await getTransmittalStageList(details.stage_seq, {
          rcpt: rcpts,
        });
        let data = { ...userStageAction };
        for (let i = 0; i < details.my_rcpt_type.length; i++) {
          for (let [key, value] of Object.entries(data)) {
            let recipient_type = details.my_rcpt_type[i]["rcpt_category"];

            if (details.my_rcpt_type[i]["rcpt_category"] === "ISSUER") {
              recipient_type = "RESPONSIBLE";
            }
            if (value !== "Y") {
              if (key === "IS_ATTACHMENT_READABLE") {
                data[key] = details.my_rcpt_type[i]["attachment_readable"];
              } else {
                let keyToLower = key.toLowerCase();
                data[key] = stagelist.data.stageList.filter(
                  (obj) =>
                    obj.stage_name === details.stageName &&
                    obj.rcpt_type === recipient_type
                )[0][keyToLower];
              }
            } else {
              data[key] = "Y";
            }
          }
          setUserStageAction({ ...userStageAction, ...data });
        }
        getDetailsHiddenLoading();
        setLoadingFinish(true);
      };
      fetchTransmittalAction();
    }
  }, [setUserStageAction]);

  return (
    <Fragment>
      {getDetailsLoading}
      {updateDetailsLoading}
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <Alert
        open={alertOpen}
        alertType={alertData.type}
        alertTitle={alertData.title}
        alertContent={alertData.content}
        handleClose={() => setAlertOpen(false)}
      />
      <ToCirculationConfirmDialog
        open={xmtlToCirculateDialogOpen}
        type={"fromXMTL"}
        dialogTitle={xmtlToCirculateDialogData.dialogTitle}
        dialogContent={xmtlToCirculateDialogData.dialogContent}
        xmtl_seq={xmtlToCirculateDialogData.xmtl_seq}
        ref_no={xmtlToCirculateDialogData.ref_no}
        buildAlert={buildAlert}
        circulationHandleClose={circulationHandleClose}
        transmittal={xmtlToCirculateDialogData.transmittal}
        confirmAction={xmtlToCirculateDialogData.confirmAction}
        cancelAction={xmtlToCirculateDialogData.cancelAction}
        confirmDialogHandleClose={xmtlToCirculateDialogHandleClose}
      />
      <SaveWarnDialog
        open={saveWarnDialogOpen}
        dialogTitle={saveWarnDialogData.dialogTitle}
        dialogContent={saveWarnDialogData.dialogContent}
        saveAction={saveWarnDialogData.saveAction}
        dontSaveAction={saveWarnDialogData.dontSaveAction}
        cancelAction={saveWarnDialogData.cancelAction}
      />

      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <FullScreenDialog
        open={filePreviewDialogOpen}
        dialogTitle={"Transmittal Attachment File Preview"}
        formContent={
          <WebViewer
            property={filePreviewProperty}
            readOnly={true}
            zoom={false}
            move={false}
            ocr={false}
            // closeDoc={webViewerDocumentClose}
          />
        }
        button={fileAttachmentPreviewDialogBtn}
        handleClose={filePreviewDialogHandleClose}
      />
      <NormalDialog
        open={selectHardCopyDialogOpen}
        dialogTitle={`Add Attachments`}
        formContent={
          <TransmittalAttachments
            submissionValue={submissionValue}
            setSubmissionValue={setSubmissionValue}
            softCopyTemplate={softCopyTemplate}
            setSoftCopyTemplate={setSoftCopyTemplate}
            setSelectHardCopyDialogOpen={setSelectHardCopyDialogOpen}
            isNew={isNew}
          />
        }
        size={"lg"}
        height={700}
        button={hardCopyDialogBtn}
        handleClose={selectHardCopyHandleClose}
      />
      <NormalDialog
        open={selectUserDialogOpen}
        dialogTitle={`Select ${dialogOpenName} Recipients`}
        formContent={
          <TransmittalRecipientForm
            submissionValue={submissionValue}
            recipientType={recipientType}
            userGroupType={userGroupType}
            internalOnly={internalOnly}
            getUserListLoading={getUserListLoading}
            getGroupListLoading={getGroupListLoading}
            internalUserList={internalUserList}
            externalUserList={externalUserList}
            userGroupList={userGroupList}
            reciptentChipAdd={reciptentChipAdd}
            reciptentChipRemove={reciptentChipRemove}
            leftCcUserRcpt={leftCcUserRcpt}
            setLeftCcUserRcpt={setLeftCcUserRcpt}
            rightCcUserRcpt={rightCcUserRcpt}
            setRightCcUserRcpt={setRightCcUserRcpt}
            leftCcGroupRcpt={leftCcGroupRcpt}
            setLeftCcGroupRcpt={setLeftCcGroupRcpt}
            rightCcGroupRcpt={rightCcGroupRcpt}
            setRightCcGroupRcpt={setRightCcGroupRcpt}
            leftResponsibleUserRcpt={leftResponsibleUserRcpt}
            setLeftResponsibleUserRcpt={setLeftResponsibleUserRcpt}
            rightResponsibleUserRcpt={rightResponsibleUserRcpt}
            setRightResponsibleUserRcpt={setRightResponsibleUserRcpt}
            leftResponsibleGroupRcpt={leftResponsibleGroupRcpt}
            setLeftResponsibleGroupRcpt={setLeftResponsibleGroupRcpt}
            rightResponsibleGroupRcpt={rightResponsibleGroupRcpt}
            setRightResponsibleGroupRcpt={setRightResponsibleGroupRcpt}
            leftApproveUserRcpt={leftApproveUserRcpt}
            setLeftApproveUserRcpt={setLeftApproveUserRcpt}
            rightApproveUserRcpt={rightApproveUserRcpt}
            setRightApproveUserRcpt={setRightApproveUserRcpt}
            leftApproveGroupRcpt={leftApproveGroupRcpt}
            setLeftApproveGroupRcpt={setLeftApproveGroupRcpt}
            rightApproveGroupRcpt={rightApproveGroupRcpt}
            setRightApproveGroupRcpt={setRightApproveGroupRcpt}
            leftSecondApproveUserRcpt={leftSecondApproveUserRcpt}
            setLeftSecondApproveUserRcpt={setLeftSecondApproveUserRcpt}
            rightSecondApproveUserRcpt={rightSecondApproveUserRcpt}
            setRightSecondApproveUserRcpt={setRightSecondApproveUserRcpt}
            leftSecondApproveGroupRcpt={leftSecondApproveGroupRcpt}
            setLeftSecondApproveGroupRcpt={setLeftSecondApproveGroupRcpt}
            rightSecondApproveGroupRcpt={rightSecondApproveGroupRcpt}
            setRightSecondApproveGroupRcpt={setRightSecondApproveGroupRcpt}
            leftThirdApproveUserRcpt={leftThirdApproveUserRcpt}
            setLeftThirdApproveUserRcpt={setLeftThirdApproveUserRcpt}
            rightThirdApproveUserRcpt={rightThirdApproveUserRcpt}
            setRightThirdApproveUserRcpt={setRightThirdApproveUserRcpt}
            leftThirdApproveGroupRcpt={leftThirdApproveGroupRcpt}
            setLeftThirdApproveGroupRcpt={setLeftThirdApproveGroupRcpt}
            rightThirdApproveGroupRcpt={rightThirdApproveGroupRcpt}
            setRightThirdApproveGroupRcpt={setRightThirdApproveGroupRcpt}
            leftToExternalUserRcpt={leftToExternalUserRcpt}
            setLeftToExternalUserRcpt={setLeftToExternalUserRcpt}
            rightToExternalUserRcpt={rightToExternalUserRcpt}
            setRightToExternalUserRcpt={setRightToExternalUserRcpt}
            leftToExternalGroupRcpt={leftToExternalGroupRcpt}
            setLeftToExternalGroupRcpt={setLeftToExternalGroupRcpt}
            rightToExternalGroupRcpt={rightToExternalGroupRcpt}
            setRightToExternalGroupRcpt={setRightToExternalGroupRcpt}
          />
        }
        size={"lg"}
        height={700}
        button={recipientDialogBtn}
        handleClose={selectRcptDialogHandleClose}
      />
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <ReturnCommentDialog
        open={returnCommentDialogOpen}
        xmtl_seq={returnCommentDialogData.xmtl_seq}
        my_rcpt_type={returnCommentDialogData.my_rcpt_type}
        stageCode={returnCommentDialogData.stageCode}
        setOpenDialog={setOpenDialog}
        dialogTitle={returnCommentDialogData.dialogTitle}
        dialogContent={returnCommentDialogData.dialogContent}
        returnCommentAction={returnCommentDialogData.commentAction}
        returnCommentDialogHandleClose={returnCommentDialogHandleClose}
        cancelAction={returnCommentDialogData.cancelAction}
        buildAlert={buildAlert}
      />
      {(loadingFinish || isNew) && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={classes.detailInformation}>
              <div className={classes.itemRoot}>
                {!isNew && (
                  <>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1">
                        Transmittal Stage:
                        <div className={classes.itemText}>
                          {submissionValue.stageName}
                        </div>
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6">
                        Transmittal Reference Number:
                        <div className={classes.itemText}>
                          {submissionValue.ref_no}
                        </div>
                      </Typography>
                      <hr className={classes.elementDivider} />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1">
                        Issued By:
                        <div className={classes.itemText}>
                          {submissionValue.createuser}
                        </div>
                      </Typography>
                    </Grid>
                  </>
                )}
                <Grid>
                  <TransmittalAssignList
                    selectRcptDialogHandleOpen={selectRcptDialogHandleOpen}
                    handleRecipientClipClick={handleRecipientClipClick}
                    handleRecipientClipClose={handleRecipientClipClose}
                    removeRecipientAction={removeRecipientAction}
                    internalOnly={internalOnly}
                    anchorEl={anchorEl}
                    openPopoverId={openPopoverId}
                    setSubmissionValue={setSubmissionValue}
                    submissionValue={submissionValue}
                    validate={validate}
                    validationErrors={validationErrors}
                    isNew={isNew}
                    editable={editable}
                  />
                </Grid>
                <Grid>
                  <TransmittalMaster
                    selectHardCopyHandleOpen={selectHardCopyHandleOpen}
                    deleteAtthConfirmAction={deleteAtthConfirmAction}
                    setSubmissionValue={setSubmissionValue}
                    submissionValue={submissionValue}
                    validate={validate}
                    validationErrors={validationErrors}
                    isNew={isNew}
                    editable={editable}
                    viewFileAction={viewFileAction}
                    downloadFileAction={downloadFileAction}
                    userStageAction={userStageAction}
                  />
                </Grid>
                {userStageAction.IS_COMMENT_READABLE === "Y" && (
                  <Grid>
                    <TransmittalComment
                      xmtl_seq={xmtlSeq}
                      postCommentConfirmAction={postCommentConfirmAction}
                      submissionValue={submissionValue}
                      submissionCommentValue={submissionCommentValue}
                      setSubmissionCommentValue={setSubmissionCommentValue}
                      commentvalidate={commentvalidate}
                      commentvalidationErrors={commentvalidationErrors}
                      userStageAction={userStageAction}
                    />
                  </Grid>
                )}
                {userStageAction.IS_RETURNCOMMENT_READABLE === "Y" &&
                  submissionValue.is_returned === "Y" && (
                    <Grid>
                      <TransmittalReturnComment
                        xmtl_seq={xmtlSeq}
                        submissionValue={submissionValue}
                        submissionCommentValue={submissionCommentValue}
                        setSubmissionCommentValue={setSubmissionCommentValue}
                        userStageAction={userStageAction}
                      />
                    </Grid>
                  )}
                <Grid container spacing={1}>
                  <div className={classes.rfibtnGroup}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.formBtn}
                      onClick={() => {
                        cancelandBackAction();
                      }}
                    >
                      Cancel and Back
                    </Button>
                    {isNew && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={() => {
                          createTransmittalAction();
                        }}
                      >
                        Create
                      </Button>
                    )}
                    {!editable && userStageAction.IS_UPDATABLE === "Y" && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={handleEditClick}
                      >
                        Edit
                      </Button>
                    )}
                    {editable && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={() => handleSaveClick(xmtlSeq)}
                      >
                        Save
                      </Button>
                    )}
                    {userStageAction.IS_APPROVABLE === "Y" && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={() => {
                          approveTransmittalConfirmAction(xmtlSeq);
                        }}
                      >
                        Approve
                      </Button>
                    )}
                    {userStageAction.IS_APPROVABLE === "Y" && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={() => {
                          returnTransmittalConfirmAction(xmtlSeq);
                        }}
                      >
                        Return
                      </Button>
                    )}
                    {userStageAction.IS_TRANSMITTABLE === "Y" && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={() => {
                          sendTransmittalConfirmAction(xmtlSeq);
                        }}
                      >
                        Transmit
                      </Button>
                    )}

                    {!isNew && !editable && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={() => {
                            circulateAction();
                          }}
                        >
                          Circulate
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={() => {
                            eFilingAction();
                          }}
                        >
                          Save to Efiling
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={generatePdf}
                        >
                          Download Transmittal Document
                        </Button>
                      </>
                    )}
                    {userStageAction.IS_CLOSABLE === "Y" && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={() => {
                          closeTransmittalConfirmAction(xmtlSeq);
                        }}
                      >
                        Close
                      </Button>
                    )}
                  </div>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
};
export default TransmittalDetailsForm;
